import React from "react";
import useAuth from "../../../../Hooks/useAuth";
import { useGetManualQuotaRequestQuery, useGenerateManualQuotaRequestCodeMutation } from "../../../../store/storageRoles/devicesSharedApi";
import ManualQuotaRequestCard from "../ManualQuotaRequestCard";

/**
 * Merkez (storage) — cihazın güncel manuel kota talebi (QR, makine 3.9.4+) (#115).
 * Talep yoksa hiçbir şey çizmez (eski sürüm makinede bugünkü çekmece aynen).
 */
export default function ManualQuotaRequestSection({ deviceId }) {
  const { auth } = useAuth();
  const token = auth?.accessToken;
  // Sayaç geriye giden talepte onaylı üretim (#123) — sunucu kuralının panel
  // karşılığı (admin / merkez yönetimi); kesin karar sunucuda (değilse 409).
  const canForce =
    auth?.role === "admin" || (auth?.role === "storage" && auth?.subRole === "management");
  const { data } = useGetManualQuotaRequestQuery({ token, deviceId }, { skip: !token || !deviceId, refetchOnMountOrArgChange: true });
  const [generate, { isLoading, error, reset }] = useGenerateManualQuotaRequestCodeMutation();

  const request = data?.data?.request;
  if (!request) return null;

  const handleGenerate = async (newQuota, force = false) => {
    reset();
    try {
      await generate({
        token,
        deviceId,
        requestId: request.id,
        newQuota,
        ...(force ? { force: true } : {}),
      }).unwrap();
    } catch (_) {
      // hata kartta gösterilir
    }
  };

  return (
    <ManualQuotaRequestCard
      request={request}
      onGenerate={handleGenerate}
      isGenerating={isLoading}
      error={error ? error?.data?.message || "Kod üretilemedi." : ""}
      canForce={canForce}
    />
  );
}
